<template>
	<DialogV2 ref="dialog"
		:title="$t('text.contingentAvailable')"
		:confirmLabel="$t('text.confirmRebooking')"
		:cancelLabel="$t('text.back')"
		:onConfirm="confirm"
		:onCancel="cancel"
		width="560px"
		height="auto"
		@close="resolve(false)"
	>
		<template #content>
			<div class="PriceChangeDialog" data-cy="priceChangeDialog">
				<div class="warning-header">
					<v-icon size="40" color="#ffb400">mdi-alert</v-icon>
					<div>
						<div class="warning-title">{{ $t('text.priceChangeDetected') }}</div>
						<div class="warning-text">{{ $t('text.priceChangeConfirmQuestion') }}</div>
					</div>
				</div>
				<table class="diff-table">
					<thead>
						<tr>
							<th>{{ $t('text.ticketType') }} &amp; {{ $t('text.ticketCategory') }}</th>
							<th class="price-column">{{ $t('text.price') }}</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="diff in diffs" :key="diff.orderItemId">
							<td>
								<div class="service-subtitle">{{ diff.ticketCategory }}</div>
								<div>{{ diff.ticketType || diff.name }}</div>
							</td>
							<td class="price-column">
								<div class="old-price"><s>{{ formatPrice(diff.oldPrice, diff.currency) }}</s></div>
								<div class="new-price">{{ formatPrice(diff.newPrice, diff.currency) }}</div>
							</td>
						</tr>
					</tbody>
				</table>
				<v-checkbox
					:model-value="notifyServiceProviders"
					:label="$t('text.informServiceProvider')"
					color="blue" hide-details density="compact"
					data-cy="priceDialogNotifyCheckbox"
					@update:model-value="$emit('update:notifyServiceProviders', $event)"
				/>
			</div>
		</template>
	</DialogV2>
</template>

<script>
import DialogV2 from '../../../components/common/DialogV2.vue'
import { formatPrice } from './rebooking-utils'

export default {
	name: 'PriceChangeDialog',
	components: { DialogV2 },
	props: {
		notifyServiceProviders: Boolean,
	},
	data: () => ({
		diffs: [],
		resolver: null,
	}),
	methods: {
		formatPrice,
		// resolves true when the user confirms the rebooking, false on back/close
		open(diffs) {
			this.diffs = diffs
			this.$refs.dialog.open()
			return new Promise(resolve => { this.resolver = resolve })
		},
		resolve(confirmed) {
			this.resolver?.(confirmed)
			this.resolver = null
		},
		confirm() {
			this.resolve(true)
		},
		cancel() {
			this.resolve(false)
		},
	},
}
</script>

<style scoped>
.warning-header {
	display: flex;
	gap: 16px;
	align-items: flex-start;
	margin-bottom: 16px;
}
.warning-title { font-size: 17px; font-weight: 600; }
.warning-text { color: #666; }
.diff-table { width: 100%; border-collapse: collapse; margin-bottom: 8px; }
.diff-table th {
	text-align: left;
	font-size: 13px;
	font-weight: 600;
	padding: 8px 4px;
	border-bottom: 1px solid rgba(0, 0, 0, 0.15);
}
.diff-table td { padding: 10px 4px; border-bottom: 1px solid rgba(0, 0, 0, 0.08); }
.service-subtitle { font-size: 11px; color: #8f8f8f; }
/* th/td prefix needed: .diff-table th's text-align:left has equal specificity and would
   otherwise win by source order, leaving the header unaligned with the right-aligned cells */
th.price-column, td.price-column { text-align: right; white-space: nowrap; }
.old-price { font-size: 12px; color: #8f8f8f; }
.new-price { font-weight: 600; }
</style>
